import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeNotify } from './notify.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'METRICS_INDEX',
    CHANGE: 'METRICS_CHANGE',
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (action_id = null, link_id = null , periodo, initial = null, final = null) => dispatch => {
    return HttpAuth.post('/metrics/'+ action_id, {
        'link_id' : link_id,
        'periodo' : periodo,
        'initial' : initial,
        'final': final
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => {
        dispatch( changeLoading({ open: false }) )

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    if(typeof error.response.data.error_code !== undefined) {
                        dispatch(changeVerifySms({
                            open: true,
                            screen_id: 'metrics.index'
                        }))
                        
                        return false
                    }
                    
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }
                }
            }
        }
    })
}

export const region = (action_id = null, link_id = null , initial = null, final = null) => dispatch => {
    return HttpAuth.post('/metrics/region/'+ action_id, {
        'link_id' : link_id,
        'initial' : initial,
        'final': final
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => {
        dispatch( changeLoading({ open: false }) )

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    if(typeof error.response.data.error_code !== undefined) {
                        dispatch(changeVerifySms({
                            open: true,
                            screen_id: 'metrics.index'
                        }))
                        
                        return false
                    }
                    
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }
                }
            }
        }
    })
}

export const getUtms = (action_id = null, link_id = null, utm_source , periodo, initial = null, final = null) => dispatch => {
    return HttpAuth.post('/metrics/utms/'+ action_id, {
        'link_id' : link_id,
        'utm_source': utm_source,
        'periodo' : periodo,
        'initial' : initial,
        'final': final
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => {
        dispatch( changeLoading({ open: false }) )

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    if(typeof error.response.data.error_code !== undefined) {
                        dispatch(changeVerifySms({
                            open: true,
                            screen_id: 'metrics.index'
                        }))
                        
                        return false
                    }
                    
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }
                }
            }
        }
    })
}